<template>
  <div class="wrapper" :class="{ lock: lockScrollValue }">

    <main>
      <slot></slot>
    </main>


  </div>
</template>

<script setup>
import { useInstitutionStore } from '@entities/institution';

const storeInstitution = useInstitutionStore();

const faviconUrl = computed(() =>
  storeInstitution.institution?.visual?.favicon_file || '/favicon.ico',
);

const head = useLocaleHead({
  addDirAttribute: true,
  addSeoAttributes: true,
});

useHead({
  htmlAttrs: {
    lang: head.value.htmlAttrs.lang,
    dir: head.value.htmlAttrs.dir,
  },
  meta: [],
  link: [
    {
      rel: 'icon',
      type: 'image/x-icon',
      href: faviconUrl.value,
    },
  ],
  // Сторонних скриптов в <head> нет намеренно. Здесь висели Fancybox, Yandex Maps
  // и VK ID SDK — три чужих бандла на каждой странице сайта. Fancybox не
  // используется в коде вообще, карта нужна только в модалке адреса и админской
  // карте зон, VK ID — только в виджете входа: оба грузятся по требованию,
  // см. shared/lib/platform (loadScriptOnce).
});
if (process.client) {
  function setFavicon(url) {
    let link = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'icon';
      document.head.append(link);
    }
    link.href = url;
  }

  watch(
    faviconUrl,
    (newUrl) => {
      setFavicon(newUrl);
    },
    { immediate: true },
  );
}
</script>

<style lang="scss">
.wrapper {
  @apply flex max-md:overflow-hidden min-h-screen flex-col;

  > main {
    @apply flex-auto;
  }

  &.lock {
    @apply h-screen;
  }
}
</style>
